function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.698 14.99C19.825 13.092 21 10.943 21 10.943s-3.75-6.875-10-6.875a8.785 8.785 0 00-3.488.735l.963.963A7.43 7.43 0 0111 5.318c2.65 0 4.848 1.46 6.46 3.07a16.42 16.42 0 012.075 2.555c-.073.108-.153.228-.244.36-.419.6-1.038 1.4-1.831 2.193-.207.207-.422.41-.646.608l.884.886z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.121 12.412A4.376 4.376 0 009.53 6.82l1.028 1.029a3.125 3.125 0 013.537 3.536l1.027 1.027zm-3.678 1.624l1.027 1.028A4.375 4.375 0 016.877 9.47l1.03 1.029a3.125 3.125 0 003.536 3.536z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.188 7.78c-.225.2-.442.402-.648.609-.775.78-1.47 1.635-2.075 2.554l.244.36c.418.6 1.037 1.4 1.831 2.193 1.611 1.611 3.811 3.071 6.46 3.071.895 0 1.738-.166 2.525-.45l.963.965c-1.1.481-2.287.731-3.488.735-6.25 0-10-6.874-10-6.874S2.174 8.79 4.301 6.895l.885.886.002-.001z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.058 18.885l-15-15L3.943 3l15 15-.885.885z"
});
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref, _ref2, _ref3, _ref4);
}
export default SvgEye;